import * as API from '../api'
import { generate_timestamp } from '../utils/timestamp'
import { openOrDownloadPdf, downloadFile } from '../utils/downloads'

export const FETCHING_AREAS_LIST = 'FETCHING_AREAS_LIST'
export const FETCH_AREAS_LIST = 'FETCH_AREAS_LIST'
export const FETCH_AREAS_LIST_ERROR = 'FETCH_AREAS_LIST_ERROR'

export const FETCH_CONTROLLED_COMPONENTS = 'FETCH_CONTROLLED_COMPONENTS'
export const FETCHING_CONTROLLED_COMPONENTS = 'FETCHING_CONTROLLED_COMPONENTS'
export const FETCH_CONTROLLED_COMPONENTS_ERROR = 'FETCH_CONTROLLED_COMPONENTS_ERROR'

export const FETCHING_SUPERVISORIES_LIST = 'FETCHING_SUPERVISORIES_LIST'
export const FETCH_SUPERVISORIES_LIST = 'FETCH_SUPERVISORIES_LIST'
export const FETCH_SUPERVISORIES_LIST_ERROR = 'FETCH_SUPERVISORIES_LIST_ERROR'

export const FETCH_CHANGE_AREAS = 'FETCH_CHANGE_AREAS'
export const FETCH_CHANGE_CONTROLLED_COMPONENTS = 'FETCH_CHANGE_CONTROLLED_COMPONENTS'
export const FETCH_CHANGE_SUPERVISORIES = 'FETCH_CHANGE_SUPERVISORIES'

export const FETCH_DOWNLOAD_PDF = 'FETCH_DOWNLOAD_PDF'
export const FETCHING_DOWNLOAD_PDF = 'FETCHING_DOWNLOAD_PDF'
export const FETCH_DOWNLOAD_PDF_ERROR = 'FETCHING_DOWNLOAD_PDF_ERROR'

export const FETCH_DOWNLOAD_XLS = 'FETCH_DOWNLOAD_XLS'
export const FETCHING_DOWNLOAD_XLS = 'FETCHING_DOWNLOAD_XLS'
export const FETCH_DOWNLOAD_XLS_ERROR = 'FETCH_DOWNLOAD_XLS_ERROR'

export const fetchAreas = (text) => {
  return dispatch => {
    dispatch({ type: FETCHING_AREAS_LIST, value: true });

    return new Promise((resolve, reject) => {
      API.area
        .getAreas(text = '')
        .then(response => {
          const handleAreas = areas => {
            return areas.map(area => (
                { value: area.id, isDefault: area.is_default, label: area.code ?  `${area.code} - ${area.name}` : area.name }
            ));
          }

          const areas = handleAreas((response || {}).data || [])

          dispatch({
            type: FETCH_AREAS_LIST,
            items: areas,
            last_update: ((response || {}).data || {}).last_update,
          });

          resolve(areas)
        })
        .catch(err => {
          dispatch({ type: FETCH_AREAS_LIST_ERROR });
          reject(err)
        });
    })
  };
};

export const fetchControlledComponent = () => {
  return dispatch => {
    dispatch({ type: FETCHING_CONTROLLED_COMPONENTS, value: false })

    return API.controlledProducts
      .getControlledComponentsCollection()
      .then(response => {
        const { data = [] } = response
        const { items } = data

        const controlledComponentList = items.map(item => {
          return { label: item.name, value: item.id }
        })

        dispatch({
          type: FETCH_CONTROLLED_COMPONENTS,
          items: controlledComponentList
        })
      }).catch(err => {
        dispatch({type: FETCH_CONTROLLED_COMPONENTS_ERROR, value: false })
      })
  }
}

export const fetchSupervisories = () => {
  return dispatch => {
    dispatch({ type: FETCHING_SUPERVISORIES_LIST, value: true })

    return API.controlledProducts
      .getSupervisoriesCollection()
      .then(response => {
        const { data = [] } = response
        const { items } = data

        const supervisoriesList = items.map(item => {
          return { label: item.name, value: item.id }
        })

        dispatch({
          type: FETCH_SUPERVISORIES_LIST,
          items: supervisoriesList
        })
      }).catch(err => {
        dispatch({type: FETCH_SUPERVISORIES_LIST_ERROR })
      })
  }
}

export const fetchChangeAreas = areas => {
  return dispatch => {
    dispatch({ 
      type: FETCH_CHANGE_AREAS, 
      areas,
    })
  }
}

export const fetchChangeControlledComponents = controlledComponents => {
  return dispatch => {
    dispatch({
      type: FETCH_CHANGE_CONTROLLED_COMPONENTS,
      controlledComponents,
    })
  }
}

export const fetchChangeSupervisories = supervisories => {
  return dispatch => {
    dispatch({ 
      type: FETCH_CHANGE_SUPERVISORIES, 
      supervisories,
    })
  }
}

export const fetchDownloadPdf = (areas  = [], controlledComponents  = [], supervisories  = []) => {
  return dispatch => {
    dispatch({ type: FETCHING_DOWNLOAD_PDF })

    const areaIds = areas.map(item => item.value)
    const controlledComponentIds = controlledComponents.map(item => item.value)
    const supervisoryIds = supervisories.map(item => item.value)

    return API.controlledProductReport
      .downloadPdf(areaIds, controlledComponentIds, supervisoryIds)
      .then(response => {
        dispatch({ type: FETCH_DOWNLOAD_PDF })
        const { data } = response

        const link = document.createElement('a')

        const filename = 'Produtos Controlados ' + generate_timestamp() + '.pdf'

        const blob = new Blob([data], {
          type: 'application/PDF',
          charset: 'UTF-8'
        })

        openOrDownloadPdf(link, blob, filename)
      }).catch(err => {
        dispatch({ type: FETCH_DOWNLOAD_PDF_ERROR })
      })
  }
}

export const fetchDownloadXls = (areas = [], controlledComponents = [], supervisories = []) => {
  return dispatch => {
    dispatch({
      type: FETCHING_DOWNLOAD_XLS
    })

    const areaIds = areas.map(item => item.value)
    const controlledComponentIds = controlledComponents.map(item => item.value)
    const supervisoryIds = supervisories.map(item => item.value)

    return API.controlledProductReport
      .downloadXls(areaIds, controlledComponentIds, supervisoryIds)
      .then(response => {

        const filename = 'Produtos Controlados em ' + generate_timestamp() + '.xlsx'

        const blob = new Blob([response.data], {
          type: 'application/xlsx',
          charset: 'UTF-8'
        })

        const link = document.createElement('a')

        dispatch({
          type: FETCH_DOWNLOAD_XLS
        })

        downloadFile(link, blob, filename)
      })
      .catch(err => {
        dispatch({
          type: FETCH_DOWNLOAD_XLS_ERROR
        })
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/controlledProductReport.js